import { useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineMenuUnfold, AiOutlineClose } from "react-icons/ai";
import PropTypes from "prop-types";
import logo from "../assets/Logo.jpeg";


// Array of link objects for easy mapping
const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Testimonials", path: "/testimonials" },
  { name: "Blog", path: "/blog" },
  { name: "Contact", path: "/contact" },
];

const Navbar = () => { // Accept the scroll function as a prop
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  // eslint-disable-next-line react/prop-types
  const NavLink = ({ name, path }) => (
    <Link
      to={path}
      onClick={closeMenu}
      className="hover:text-secondary transition-all cursor-pointer block py-2 px-4"
    >
      {name}
    </Link>
  );

  return (
    <div className="fixed w-screen z-50">
      <div className="flex justify-between p-4 md:px-32 px-5 bg-white text-black shadow-[0_3px_10px_rgb(0,0,0,0.2)]">
        <div className="flex items-center cursor-pointer">
          <img src={logo} alt="Logo" className="h-10 w-auto" />
        </div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center font-medium text-sm gap-8">
          {navLinks.map((link) => (
            <NavLink key={link.name} {...link} />
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center">
          {menuOpen ? (
            <AiOutlineClose size={25} onClick={toggleMenu} className="text-black cursor-pointer" />
          ) : (
            <AiOutlineMenuUnfold size={25} onClick={toggleMenu} className="text-black cursor-pointer" />
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="absolute bg-white text-black left-0 top-20 font-semibold text-sm text-center pt-8 pb-4 w-full transition-transform duration-300">
          {navLinks.map((link) => (
            <NavLink key={link.name} {...link} />
          ))}
        </div>
      )}
    </div>
  );
};

Navbar.propTypes = {
  scrollToAbout: PropTypes.func,
};

export default Navbar;


